import { Component, ChangeDetectorRef } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { CustomerReportingFilterService } from '../../services/customer-reporting-filter.service';
import { CustomerReportingModalService } from '../../services/customer-reporting-modal.service';
import { Observable, Subscription, Subject, takeUntil, filter } from 'rxjs';

@Component({
  selector: 'app-invoice-history',
  templateUrl: './invoice-history.page.html',
  styleUrls: ['./invoice-history.page.scss'],
})
export class InvoiceHistoryPageComponent {
  deliveryDateRange$: Observable<string>;
  numberSelectedFilters$: Observable<number>;
  modalFilterSub: Subscription;
  destroyed$ = new Subject<void>();

  constructor(
    public platformService: PlatformService,
    readonly panAppState: PanAppState,
    private filterService: CustomerReportingFilterService,
    private customerReportingModal: CustomerReportingModalService,
    private cdr: ChangeDetectorRef,
  ) {}

  get isDesktop(): boolean {
    return (
      this.platformService?.platformType ===
      this.platformService?.platformEnum?.desktop
    );
  }

  get isTablet(): boolean {
    return (
      this.platformService?.platformType ===
      this.platformService?.platformEnum?.tablet
    );
  }

  get isMobile(): boolean {
    return (
      this.platformService?.platformType ===
      this.platformService?.platformEnum?.mobile
    );
  }

  get isTouch(): boolean {
    return this.isTablet || this.isMobile;
  }

  get platformClass(): string {
    if (this.isDesktop) {
      return 'desktop';
    }
    if (this.isTablet) {
      return 'tablet';
    }
    if (this.isMobile) {
      return 'mobile';
    }
    return '';
  }

  ionViewWillEnter() {
    this.panAppState.setPageTitle('Invoice History');
    this.deliveryDateRange$ = this.filterService.deliveryDateRange$;
    this.numberSelectedFilters$ = this.filterService.numberSelectedFilters$;
    this.modalFilterSub = this.customerReportingModal.filtersSelected
      .pipe(takeUntil(this.destroyed$))
      .subscribe(event => {
        this.filterService.onFilterChange(event);
      });
    this.filterService.filtersUpdated$
      .pipe(
        filter(updated => updated),
        takeUntil(this.destroyed$),
      )
      .subscribe(() => {
        this.cdr.detectChanges();
      });
  }

  ionViewWillLeave() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  openModal(quickDate: boolean = false) {
    this.customerReportingModal.open(
      this.filterService.fromDate,
      this.filterService.toDate,
      this.filterService.selectedCustomers,
      quickDate,
    );
  }

  resetFilters(fromDestroy: boolean = false) {
    this.filterService.resetFilters();
  }
}
